const ShortenedTitle = ({ title, maxChars }) => {
  if (title.length > maxChars) {
    return title.slice(0, maxChars).concat("...");
  } else {
    return title;
  }
};

ShortenedTitle.defaultProps = {
  title: "",
  maxChars: 20,
};

export default ShortenedTitle;
